// @ts-nocheck
import "../../sass/pages/don-abel.scss";
const dialog = document.querySelector("dialog")
const close = document.getElementById("close")
const video = document.getElementById("video") as any
const players = [...document.getElementsByClassName("eternos__play")] as HTMLElement[]
const back = document.querySelector(".eternos__button") as HTMLElement

window.addEventListener("load", () => {
    players.forEach(item => {
        item.addEventListener("click", openDialog)
    })
    close.addEventListener("click", closeDialog)
    back.addEventListener("click", () => {
        window.location.replace("/eterno")
    })
    sendDatalayer()
});

const openDialog = () => {
    dialog.showModal()
}
const closeDialog = () => {
    video.src = video.src
    dialog.close()

}

const sendDatalayer = () => {

    const btn = document.querySelector('.eternos__bannerCans__right a')
    btn.addEventListener("click", () => {

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'GAEvent',
            event_category: 'Content',
            event_action: 'button',
            event_label: 'Comprar ahora en Tada',
            interaction: 'true',
            component_name: 'button_comprarahora',
            element_text: 'Comprar ahora en Tada',
            campaign_description: 'Eternos'
        })
    });

    //dataLayer SUMATE AL LEGADO
    const btnSumateLegado = document.getElementById("btn_sumate_legado");
    btnSumateLegado.addEventListener("click", () => {

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'button',
            'event_label': 'Súmate al legado',
            'interaction': 'true',
            'component_name': 'button_sumateallegado',
            'Element_text': 'Súmate al legado',
            'campaign_description': 'Eternos'
        })
    });

    //datalayer sumate al legado
    const btnSumateLegado = document.getElementById("sumate_al_legado");
    if (btnSumateLegado) {
        btnSumateLegado.addEventListener("click", () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'button',
                'event_label': 'Sumate al legado',
                'interaction': 'true',
                'component_name': 'button_legadoeterno',
                'element_text': 'Sumate al legado',
                'campaign_description': 'Eternos'
            });
        })
    }

    //datalayer explora nuestra siembra
    const btnExploraSiembra = document.getElementById("explora_siembra");
    if (btnExploraSiembra) {
        btnExploraSiembra.addEventListener("click", () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'button',
                'event_label': 'Explora nuestra siembra',
                'interaction': 'true',
                'component_name': 'button_legadoeterno',
                'element_text': 'Explora nuestra siembra',
                'campaign_description': 'Eternos'
            });
        })
    }
}
